import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { Segment } from 'models/segment.model'
import styles from './styles.module.scss'

const prefixUserList = 'configuration.segments.list.table'

const prefix = `${prefixUserList}.headers`

const RowData = ({ children }) => (
  <div className={styles.rowData}>{children}</div>
)

export const useSegmentsColumns = () => {
  const { t } = useTranslation()

  type Keys = keyof Segment | 'users_count' | 'action'
  type Column<Key extends Keys = Keys> = {
    title: string
    dataIndex?: string
    key: Key
    sorteable?: boolean
    width?: number
    render?: (value: any, data: Segment) => any
    filterable?: boolean
  }

  const columns = useMemo(
    (): Column[] => [
      {
        title: t(`${prefix}.name`),
        dataIndex: 'name',
        key: 'name',
        render: (_, { name }) => <RowData>{name}</RowData>,
        sorteable: true,
      } as Column<'name'>,
      {
        title: t(`${prefix}.usersCount`),
        dataIndex: 'usersCount',
        key: 'users_count',
        render: (_, { usersCount }) => <RowData>{usersCount}</RowData>,
        sorteable: true,
      } as Column<'users_count'>,
    ],
    [t]
  )
  return columns
}

export default useSegmentsColumns
